import { Text, RichText } from '@sitecore-jss/sitecore-jss-nextjs';
import { useSitecoreContext } from 'hooks/useSitecoreContext';
import AccordionNew from 'components/Sections/Accordion/AccordionNew';
import styles from './Articles.module.scss';
import { FieldsType } from 'model/TableOfContents';

type Props = {
  articles: FieldsType;
  className?: string;
};

const Articles = ({ articles, className }: Props) => {
  const { sitecoreContext } = useSitecoreContext();
  return (
    <div className={className}>
      {articles.items.map((article) => (
        <article key={article.id} className={`${styles['article-description']} pb-7 mb-7`}>
          <Text id={article.id} tag="h2" className="mb-3" field={article.fields.title} />

          {article.fields.items.map((section, sectionIndex) => (
            <div key={section.id} className={sectionIndex !== 0 ? 'mt-8' : ''}>
              <Text
                className={`${
                  !sitecoreContext.pageEditing ? styles['hidden-subsection-title'] : ''
                } mb-2`}
                tag="h3"
                field={section.fields.subsectionTitle}
              />
              <RichText id={section.id} field={section.fields.description} />

              {section.fields?.items?.map((accordionGroup) => (
                <div key={accordionGroup.id} className="mt-6">
                  {accordionGroup.fields.items.map((accordion, accordionIndex) => (
                    <AccordionNew
                      key={accordion.id}
                      title={accordion.fields.title}
                      description={accordion.fields.description}
                      isFirst={accordionIndex === 0}
                    />
                  ))}
                </div>
              ))}
            </div>
          ))}
        </article>
      ))}
    </div>
  );
};

export default Articles;
